import { Dialog, DialogContent, DialogTitle, DialogFooter } from '@unlimitai/ui';
import { useTranslation } from 'react-i18next';

import CloseIcon from '@/assets/icons/close-icon.svg?react';
import Button from '@/shared/components/Button';
import IconButton from '@/shared/components/IconButton';

import styles from './Acmodal.module.scss';
import type { ModalProps } from './type';

const AcModal = ({
  className,
  isOpen = false,
  isConfirmLoading = false,
  isCancelLoading = false,
  children,
  cancelText = 'action.cancel',
  confirmText = 'action.confirm',
  confirmTextI18nProps,
  cancelTextI18nProps,
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = true,
  onConfirm,
  onClose,
}: ModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent
        className={className}
        aria-describedby={undefined}
        onEscapeKeyDown={(event) => {
          if (!shouldCloseOnEsc) {
            event.preventDefault();
          }
        }}
        onPointerDownOutside={(event) => {
          if (!shouldCloseOnOverlayClick) {
            event.preventDefault();
          }
        }}
      >
        <div className="ui-flex ui-items-center ui-justify-between">
          <DialogTitle>{t('description.reminder')}</DialogTitle>
          <IconButton aria-label={t('action.cancel')} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="ui-text-sm ui-leading-6">{children}</div>
        <DialogFooter className={styles.footer}>
          <Button
            className={styles.cancelButton}
            title={cancelText}
            type="secondary"
            i18nProps={cancelTextI18nProps}
            size="small"
            isLoading={isCancelLoading}
            onClick={onClose}
          />
          {onConfirm && (
            <Button
              className={styles.confirmButton}
              title={confirmText}
              i18nProps={confirmTextI18nProps}
              size="small"
              isLoading={isConfirmLoading}
              onClick={onConfirm}
            />
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
export default AcModal;
